import { createApi } from '@reduxjs/toolkit/query/react';

import { authTags } from '@/api/auth/tags';
import { baseQueryWithReAuth } from '@/api/baseApi';
import { KEYCLOAK_PROVIDER_API, LOGIN_URL, USERS_API } from '@/shared/api/constants';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQueryWithReAuth,
  tagTypes: Object.values(authTags),
  endpoints: (builder) => ({
    // При старте приложения — проверяем /me
    getMe: builder.query<any, void>({
      queryFn: async (payload, _api, _, baseQuery) => {
        const result = (await baseQuery({
          url: `${USERS_API}/me`,
          method: 'GET',
        })) as {
          data: any;
          error?: any;
        };
        //TODO: maybe redirect to error page
        if (result?.error?.status === 401) {
          // setWindowInternal(WINDOW_INTERNAL_PERMISSIONS, null);
          window.location.href = LOGIN_URL;
          // WSController.disconnect();
        }

        // setWindowInternal(WINDOW_INTERNAL_PERMISSIONS, result?.data?.permissionNames);
        return {
          data: {
            ...result?.data,
            auth: {
              permissions: result?.data?.permissionNames,
              level: result?.data?.organization?.level,
            },
          },
        };
      },
      providesTags: [authTags.USER],
      keepUnusedDataFor: 9999999,
    }),
    logout: builder.mutation<any, void>({
      query: () => ({
        url: `${KEYCLOAK_PROVIDER_API}/auth/logout`,
        method: 'POST',
      }),
      invalidatesTags: [authTags.USER],
      async onQueryStarted(_, { queryFulfilled }) {
        await queryFulfilled;
        sessionStorage.clear();
      },
    }),
  }),
});

export const { useGetMeQuery, useLogoutMutation } = authApi;
